var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0.177582H10C4.47715 0.177582 0 4.6597 0 10.1887V25.2053C0 30.7343 4.47715 35.2164 10 35.2164H25C30.5228 35.2164 35 30.7343 35 25.2053V10.1887C35 4.6597 30.5228 0.177582 25 0.177582Z",
    fill: "#B895FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63692 12.0057C9.6333 11.7785 9.67768 11.5531 9.76716 11.3442C9.85663 11.1354 9.98917 10.9479 10.1561 10.7939C10.323 10.6399 10.5206 10.523 10.7358 10.4508C10.951 10.3786 11.179 10.3527 11.4049 10.3749C13.4402 10.6216 15.4055 11.2738 17.1849 12.293L17.3849 12.4161C17.5181 12.4888 17.6673 12.5268 17.8189 12.5268C17.9706 12.5268 18.1198 12.4888 18.2529 12.4161L18.3919 12.326C18.9928 11.9656 19.6227 11.6559 20.2749 11.4V14.7437L21.9169 13.6535L23.5539 14.7437V10.469C23.7624 10.4311 23.9727 10.4037 24.1839 10.3869H24.2369C24.4634 10.3638 24.6922 10.389 24.9082 10.4608C25.1242 10.5326 25.3227 10.6494 25.4904 10.8034C25.6582 10.9574 25.7915 11.1453 25.8815 11.3546C25.9716 11.5638 26.0163 11.7898 26.0129 12.0177V21.9097C26.0033 22.3044 25.8554 22.6831 25.5951 22.9798C25.3348 23.2764 24.9787 23.472 24.5889 23.5325L24.3189 23.5655C22.1913 23.9173 20.1311 24.5974 18.2119 25.5817C18.0898 25.6424 17.9553 25.674 17.8189 25.674C17.6826 25.674 17.5481 25.6424 17.4259 25.5817L17.3929 25.5657C15.4767 24.5906 13.4225 23.9154 11.3019 23.5635L11.0649 23.5305C10.6741 23.4708 10.3168 23.2753 10.0557 22.9781C9.79453 22.681 9.64627 22.3013 9.63692 21.9057V15.4395",
    stroke: "#B895FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8242 12.6855V24.9791",
    stroke: "#B895FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5548 10.465V14.7427L21.9168 13.6525L20.2798 14.7427V11.399C21.3365 10.9758 22.4339 10.6628 23.5548 10.465V10.465Z",
    stroke: "#B895FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsCalendarIcon);
export default __webpack_public_path__ + "static/media/events-calendar-icon.7ab78ded7177e8155b806b7bd1c765c5.svg";
export { ForwardRef as ReactComponent };